import React, { type PropsWithChildren } from 'react';

import { Box } from '@atlaskit/primitives/compiled';
import { cssMap, cx } from '@atlaskit/css';
import { token, useThemeObserver } from '@atlaskit/tokens';

const layoutSectionStyles = cssMap({
	root: {
		width: '100%',
		height: '100%',
		paddingTop: token('space.800'),
		paddingBottom: token('space.500'),
		paddingLeft: token('space.500'),
	},
	// Default styles for the layout section
});

type ImageLayoutSectionProps = {
	backgroundLight: string;
	backgroundDark: string;
};

export const ImageLayoutSection = ({
	children,
	backgroundDark,
	backgroundLight,
}: PropsWithChildren<ImageLayoutSectionProps>): React.JSX.Element => {
	const { colorMode } = useThemeObserver();
	const isDarkMode = colorMode === 'dark';

	const backgroundUrl = isDarkMode ? backgroundDark : backgroundLight;
	return (
		<Box
			xcss={cx(layoutSectionStyles.root)}
			// jira/react/no-style-attribute
			// eslint-disable-next-line jira/react/no-style-attribute
			style={{ backgroundImage: `url(${backgroundUrl})` }}
		>
			{children}
		</Box>
	);
};
